import React from "react";
import { Link } from 'react-router-dom';
import cssIf from "../../../scripts/helpers/class.add.if";
import './button.scss';

const Button = ({ text, action = false, disabled = false, color = "blue", mouseEnter = () => {}, mouseLeave = () => {} }) => {

  return (

    <button 

      className={ `button button--${ color } ${ cssIf( disabled, "disabled" ) }`}
      onClick={ () => { action && action() }}
      onMouseEnter = { mouseEnter }
      onMouseLeave = { mouseLeave }
      
    >

      <div className = "button__text">{ text }</div>

    </button>

  );

}

export const ButtonRouter = ( props ) => (

  <Link to={ props.url }>
    <Button { ...props } />
  </Link>
  
)

export default Button;